import { stationsActions } from '../reducer';

import { StationsState } from '../../types';

export const updateStationsPriceSettingsUpdatingStatus = (
  updatingStatus?: StationsState['stationsPriceReportSettings']['updatingStatus']) => stationsActions
  .updateStationsPriceSettingsUpdatingStatus(updatingStatus);
